
import { defineComponent } from "vue";

export default defineComponent({
  name: "Skeleton",
  props: {
    dark: {
      type: Boolean,
      default: false,
    },
  },
});
